import { useNavigate } from 'react-router-dom'

import { Accordion, Button, Link, Image, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const DisqualifiedPostCutoffScreen = () => {
  const navigate = useNavigate()

  return (
    <div className="flex justify-center w-full">
      <div className="flex flex-col max-w-[520px]">
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/annual_taxes_background.svg"
          alt="plant"
          height={310}
          width={310}
          className="self-center"
        />
        <Text variant={TypographyStyles.DISPLAY_MD} className="mt-10">
          Important update about 2025 tax services
        </Text>

        <Text variant={TypographyStyles.BODY_MD} className="mt-4">
          Our 2025 tax support window has closed, and we&apos;re unable to
          process new filings for this tax year. We&apos;d encourage you to
          connect with a qualified local tax professional who can help you
          through the process.
          <br />
          <br />
          We&apos;re already looking ahead to the 2026 tax season and would love
          to support you then. We&apos;ll be in touch with updates on what to
          expect and how we can make things even smoother for you next year.
        </Text>

        <Text variant={TypographyStyles.H2} className="mt-10">
          Need help?
        </Text>
        <Accordion collapsible type="multiple" variant="text">
          <Accordion.Item value="can-i-access-my-documents">
            <Accordion.Trigger>
              <Text>Can I still access my tax documents?</Text>
            </Accordion.Trigger>
            <Accordion.Content>
              <Text>
                Yes! These are available in the Tax Documents section under Your
                Practice. Click here to go to your{' '}
                <Link variant="primary" href="/practice/documents?tab=taxes">
                  <Text className="underline">tax documents</Text>
                </Link>
                . To download, click on the file name, and download from your
                browser.
              </Text>
            </Accordion.Content>
          </Accordion.Item>
          <Accordion.Item value="can-i-access-my-questionaire">
            <Accordion.Trigger>
              <Text>
                Can I still access the answers to my tax questionnaire?
              </Text>
            </Accordion.Trigger>
            <Accordion.Content>
              <Text>
                Reach out to our support team via Messages, and they can help
                you download a summary of the questions we asked, and if
                applicable, your responses.
              </Text>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion>
        <div className="mt-10 justify-center flex">
          <Button onClick={() => navigate('/dashboard')}>Go to Home</Button>
        </div>
      </div>
    </div>
  )
}
